import { createIcon } from "@chakra-ui/react";

export const QuarterCircle = createIcon({
  displayName: "QuarterCircle",
  viewBox: "0 0 72 72",
  path: [
    <mask
      id="lrrwkc63ba"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="73"
      height="72"
    >
      <path fill="#D9D9D9" d="M.864 0h72v72h-72z" />
    </mask>,
    <g mask="url(#lrrwkc63ba)">
      <path
        d="m15.036 68.275-2.542-8.132-1.245-8.436.094-8.562 2.134-8.289 3.052-7.986 4.99-6.924 5.436-6.558 6.857-5.076 7.453-3.875 2.963 7.55 3.623 7.32 3.302 7.452 2.986 7.585 2.964 7.595 2.76 7.438-7.116 3.518-7.776 2.514-7.522 3.126-7.5 3.178-7.411 3.39-7.502 3.172z"
        fill="currentColor"
      />
    </g>,
  ],
  defaultProps: {
    color: "#FCBA9E",
  },
});

export default QuarterCircle;
